import { LinearProgress, LinearProgressProps, styled } from '@mui/material';

export const ProgressBar = styled(
  ({ variant = 'determinate', color = 'inherit', ...rest }: LinearProgressProps) => (
    <LinearProgress color={color} variant={variant} {...rest} />
  )
)({
  bottom: 0,
  position: 'absolute',
  width: '100%',
});
